"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _transports = require("../transports");

var useCourierTransport = function useCourierTransport(_ref) {
  var authorization = _ref.authorization,
      clientSourceId = _ref.clientSourceId,
      clientKey = _ref.clientKey,
      transport = _ref.transport,
      userSignature = _ref.userSignature,
      wsOptions = _ref.wsOptions;
  return (0, _react.useMemo)(function () {
    if (transport) {
      return transport;
    }

    if ((clientKey || authorization) && !transport) {
      return new _transports.CourierTransport({
        authorization: authorization,
        clientSourceId: clientSourceId,
        clientKey: clientKey,
        userSignature: userSignature,
        wsOptions: wsOptions
      });
    }
  }, [authorization, clientKey, transport, userSignature, wsOptions]);
};

var _default = useCourierTransport;
exports["default"] = _default;